import { MenuItem, Tooltip } from '@blueprintjs/core';
import {
  lock_hooks,
  useApplicationDetail,
  usePatchPerson,
  usePerson,
} from '@axo/shared/data-access/hooks';
import { useConfirmDialog } from '../../../hooks/utils/useConfirmDialog';
import { event_log } from '@axo/shared/data-access/types';
import styles from './MarkAsFraudButton.module.css';
import {
  KnownResourceType,
  useEventLogger,
} from '@axo/shared/data-access/event-log';
import { EventCodeACE } from '../../EventLogWrapper/event-code';

export function MarkAsFraudButton({
  applicationID,
  personID,
}: {
  applicationID: string;
  personID?: string | null;
}) {
  const patchPerson = usePatchPerson();
  const { confirm } = useConfirmDialog();
  const person = usePerson(personID);
  const app = useApplicationDetail(applicationID);
  const hasLock = lock_hooks.useCurrentUserHasLock(
    applicationID,
    app.data?.MarketCountry
  ).data;
  const appTag: event_log.Resource = {
    Type: KnownResourceType.LoanApplication,
    ID: applicationID,
  };
  const log = useEventLogger(appTag);

  const handleToggleFraud = () => {
    if (personID) {
      if (!person.data?.Fraud) {
        confirm({
          message: 'Are you sure you want to mark this application as fraud?',
          confirmText: 'Mark as fraud',
          cancelText: 'Cancel',
          confirmCallback: async () => {
            await patchPerson.mutateAsync({
              id: personID,
              data: {
                Fraud: true,
              },
            });
            log(EventCodeACE.MarkAsFraud);
          },
        });
      } else {
        confirm({
          message: 'Are you sure you want to unmark this application as fraud?',
          confirmText: 'Unmark as fraud',
          cancelText: 'Cancel',
          confirmCallback: async () => {
            await patchPerson.mutateAsync({
              id: personID,
              data: {
                Fraud: false,
              },
            });
            log(EventCodeACE.UnmarkAsFraud);
          },
        });
      }
    }
  };

  function canMarkAsFraud() {
    if (!hasLock) {
      return {
        disabled: true,
        text: 'You can only edit the application when you have locked it.',
      };
    }
    return {
      disabled: false,
      text: '',
    };
  }

  return (
    <Tooltip
      disabled={!canMarkAsFraud().disabled}
      placement={'left'}
      className={styles.tooltip}
      content={<span>{canMarkAsFraud().text}</span>}
      openOnTargetFocus={false}
    >
      <MenuItem
        icon={!person.data?.Fraud ? 'blocked-person' : 'follower'}
        onClick={handleToggleFraud}
        disabled={canMarkAsFraud().disabled}
        text={!person.data?.Fraud ? 'Mark as fraud' : 'Unmark as fraud'}
      />
    </Tooltip>
  );
}
